import { AnimatePresence } from "framer-motion"
import { useLang } from "hooks/useLang"
import { useRouter } from "next/router"
import React from "react"
import { BsTicketPerforated } from "react-icons/bs"
import { FiChevronLeft, FiHeart, FiUser } from "react-icons/fi"
import { HiOutlineTicket } from "react-icons/hi"

const SIDE_TABS = [
    {
        title: "profile",
        tab: "account",
        Icon: FiUser,
    },
    {
        title: "tickets",
        tab: "tickets",
        Icon: HiOutlineTicket,
    },
    {
        title: "orders",
        tab: "orders",
        Icon: BsTicketPerforated,
    },
    {
        title: "favorites",
        tab: "favorites",
        Icon: FiHeart,
    },
    // {
    //     title: "sell_your_ticket",
    //     tab: "marketplace",
    //     Icon: MdOutlineSell,
    // },
]

const BackButton = ({ onClick, isAr }) => (
    <FiChevronLeft
        onClick={onClick}
        className={`h-8 w-8 cursor-pointer ${isAr ? "rotate-180" : "rotate-0"}`}
    />
)

const TabItem = ({ item, isActive, onClick, t }) => (
    <div
        onClick={onClick}
        className={`profile-tab flex flex-col capitalize md:flex-row ${
            isActive ? "active" : ""
        }`}>
        <item.Icon
            className={`h-7 w-7 rounded-md p-1 ${
                isActive
                    ? "bg-red-100 md:bg-transparent"
                    : "bg-gray-100 dark:bg-primary-theme-200 md:bg-transparent md:dark:bg-transparent"
            }`}
        />
        <span className="text-center text-xs md:text-sm">{t(item.title)}</span>
    </div>
)

const LayoutContent = ({ children }) => {
    const router = useRouter()
    const { t, isAr } = useLang()

    const tab = router.pathname.split("/").pop()

    return (
        <div className="layout flex flex-col gap-10 pb-16 pt-32">
            <div className="flex flex-col gap-2 text-primary-theme-500 dark:text-white">
                <div className="flex items-center gap-2">
                    <BackButton
                        onClick={router.back}
                        isAr={isAr}
                    />
                    <span className="text-xl font-bold md:text-2xl">
                        {t("profile_title")}
                    </span>
                </div>
                <span className="text-xs dark:text-gray-400 md:text-sm">
                    {t("profile_desc")}
                </span>
            </div>
            <div className="flex min-h-[400px] flex-col items-start gap-2 md:flex-row md:gap-10">
                <div
                    className={`mb-5 flex w-full flex-row justify-center gap-8 border-b pb-2 md:sticky md:top-[100px] md:mb-0 md:w-[200px] md:flex-col md:border-b-0 md:pb-0 ${
                        isAr ? "md:border-l" : "md:border-r"
                    }`}>
                    {SIDE_TABS.map((item, index: number) => (
                        <TabItem
                            key={index}
                            item={item}
                            onClick={() =>
                                router.push(`/user/profile/${item.tab}`)
                            }
                            isActive={
                                tab === item.tab ||
                                (!tab && item.tab === "account")
                            }
                            t={t}
                        />
                    ))}
                </div>
                <AnimatePresence>
                    <div className="w-full">{children}</div>
                </AnimatePresence>
            </div>
        </div>
    )
}

export default LayoutContent
